import ProviderSingleton from '../classes/ProviderSingleton';

export default async function currentAuthUser() {
    const provider = await ProviderSingleton.getInstance()
    const signer = provider.getSigner()
    return signer.getAddress()
}
